<template>
	<section class="Banner">
		<span></span>
		<div class="item desktop" :style="{ backgroundImage: 'url(' + image + ')' }" style="background-position: center"></div>
		<div class="item mobile" :style="{ backgroundImage: 'url(' + respimage + ')' }"></div>
		<article class="box">
			<p class="title-banner">{{ titulo }}</p>
		</article>
	</section>
</template>

<script>
    export default {
        props: ["titulo", "image", "respimage"]
    }
</script>

<style lang="scss">
	.Banner {
		position: relative;

		span {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			z-index: 10;
			background: rgba(0,0,0,0.5);
		}

		.item {
			position: relative;
			height: 240px;
			background-size: cover;
			opacity: 0.5;
		}

		.box {
			width: 90%;
			height: 40px;
			position: absolute;
			left: 50%;
			top: 50%;
			margin-left: -45%;
			margin-top: -20px;
			text-align: center;
			z-index: 11;

			.title-banner {
				font-size: 45px;
				color: #ffffff;
			}
		}

	}

	@media (max-width: 640px) {
		.Banner {
			.item {
				height: 240px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/Banner.vue